/**
 * Provides a summary of an operator's payment information
 */
export class SummaryBarController {
  public static $inject = ['$translate'];
  public currentLocale: string;
  public templateName: string;
  public currentSummary: any;
  public subtitle: string;
  public showComments: boolean;

  constructor(
    private $translate: ng.translate.ITranslateService) {
    this.currentLocale = $translate.use();
    this.showComments = this.determineIfCommentsShouldBeShown();
  }

  /**
   * Builds and returns a template path based on the supplied templateName property value
   * @returns the template url
   */
  public getTemplateUrl = () => {
    return 'app/angularJS/components/summary_bar/' + this.templateName + '-summary-bar.html';
  }

  private determineIfCommentsShouldBeShown() {
    if(this.currentSummary && this.currentSummary.operator) {
      return this.currentSummary.operator.link !== '';
    } else {
      return false;
    }
  }
}